// extracted by mini-css-extract-plugin
export var linkText = "_ob-0";